import React from 'react';
import Section, { SectionHeader } from '../Section';
import { useI18n } from '../../_contexts/I18nContext';
import styles from './index.module.scss';
import CommonCases from '@/components/CommonCases';

const Cases = ({
  name = '',
  data,
  suffix
}) => {
  const I18n = useI18n();
  return /*#__PURE__*/React.createElement(Section, {
    className: styles.container,
    name: name
  }, /*#__PURE__*/React.createElement(SectionHeader, null, /*#__PURE__*/React.createElement("h2", null, I18n.t('TTS_Portal_showcase'))), /*#__PURE__*/React.createElement(CommonCases, {
    data: data
  }), suffix && /*#__PURE__*/React.createElement("div", {
    className: styles.card_button
  }, suffix));
};

export default Cases;